var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';


const TextPropertyIcon = ({ className }) => /*#__PURE__*/
_jsx("svg", {
  className: className || '',
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "2 6 20 10" }, void 0, /*#__PURE__*/

_jsx("path", {
  d: "m3 15 4-8 4 8m-7-2h6m8 2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm3-6v6",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2" }
)
);


export { TextPropertyIcon };